<template>
  <span>
    <i :class="[icon]" class="icon-custom" />
    <span v-if="$store.state.show_menu_text">
      <span>&nbsp;&nbsp;</span>
      <span class="nav-label">{{ text }}</span>
    </span>
  </span>
</template>

<script>

export default {
  name: 'profile',
  props: {
    text: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>
.nav-label {
  font-size: 13px;
  font-family: "Montserrat", sans-serif;
}

.thinner > * > * > * > * > * > * > span {
  display: none;
}


</style>
